import { render, staticRenderFns } from "./antirollback.vue?vue&type=template&id=5e68b91e&scoped=true&"
import script from "./antirollback.vue?vue&type=script&lang=js&"
export * from "./antirollback.vue?vue&type=script&lang=js&"
import style0 from "./antirollback.vue?vue&type=style&index=0&id=5e68b91e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e68b91e",
  null
  
)

export default component.exports